import AppResource from '@milestoneslabs/milestones-js-engine/src/Data/AppResource';
import UserAppResource from './UserAppResource';
import WorkspaceAppResource from './WorkspaceAppResource';

class HomeValuationRequestAppResource extends AppResource {

  /**
   * @returns {string}
   */
  appResourceType() {
    return 'home-valuation-request';
  }

  /**
   * @returns {string}
   */
  appResourceApiPrefix() {
    return 'homes/valuations/requests';
  }

  /**
   * @returns {*[]}
   */
  hidden() {
    return super.hidden().concat([
      'deleted_at',
    ]);
  }

  /**
   * @returns {*[]}
   */
  fillable() {
    return [
      'updatedAt',
      'firstName',
      'lastName',
      'email',
      'phone',
      'userUuid',
      'hubUuid',
      'respondByEmail',
      'respondByPhone',
      'meta',
      'user',
      'hub',
    ];
  }

  /**
   * @returns {*[]}
   */
  relationMap() {
    return {
      user: UserAppResource,
      hub: WorkspaceAppResource,
    };
  }

  /**
   * @returns {*[]}
   */
  relationForeignKeys() {
    return {
      user: 'user_uuid',
      hub: 'hub_uuid',
    };
  }

  /**
   * @returns {*}
   */
  validationRules() {
    return {
      firstName: {
        type: 'string',
        presence: true,
      },
      lastName: {
        type: 'string',
        presence: true,
      },
      email: {
        type: 'string',
        presence: true,
      },
      phone: {
        type: 'string',
      },
      userUuid: {
        type: 'string',
        presence: true,
      },
      hubUuid: {
        type: 'string',
        presence: true,
      },
      respondByEmail: {
        type: 'boolean',
        presence: true,
      },
      respondByPhone: {
        type: 'boolean',
        presence: true,
      },
    };
  }
}

export default HomeValuationRequestAppResource;
